import toolBar from './toolBar';
export default toolBar;



// WEBPACK FOOTER //
// ./src/components/toolBar/index.js